/**
 * @description Generate next pagination cursor for the next page.
 *              This function is used to generate the next pagination cursor
 *              to use in the 'after' query parameter.
 *              The cursor is generated by encoding the string 'arrayconnection:'
 *              and that is supported by the API V5.
 */
function generateNextPaginationCursor(currentPage, itemsPerPage) {
  return btoa("arrayconnection:".concat((currentPage || 0) * itemsPerPage - 1));
}
export default generateNextPaginationCursor;